var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM5.49999 5.50001C5.67257 5.32743 5.9524 5.32743 6.12499 5.50001L7.99999 7.37502L9.87501 5.49999C10.0476 5.3274 10.3274 5.3274 10.5 5.49999C10.6726 5.67258 10.6726 5.95241 10.5 6.125L8.62499 8.00002L10.5 9.87502C10.6726 10.0476 10.6726 10.3274 10.5 10.5C10.3274 10.6726 10.0476 10.6726 9.87499 10.5L7.99999 8.62502L6.125 10.5C5.95242 10.6726 5.67259 10.6726 5.5 10.5C5.32741 10.3274 5.32741 10.0476 5.5 9.875L7.37499 8.00002L5.49999 6.12502C5.3274 5.95243 5.3274 5.6726 5.49999 5.50001Z",
    fill: "#D1293D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMark);
export default __webpack_public_path__ + "static/media/crossMark.cc59a685f4d4c275479a9e097c11572c.svg";
export { ForwardRef as ReactComponent };